import { useState, createContext, useContext } from 'react'

const TabsContext = createContext(null)

function Tabs({ children, defaultValue, value, onChange, className = '' }) {
  const [internalValue, setInternalValue] = useState(defaultValue)
  const currentValue = value !== undefined ? value : internalValue

  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue)
    } else {
      setInternalValue(newValue)
    }
  }

  return (
    <TabsContext.Provider value={{ value: currentValue, onChange: handleChange }}>
      <div className={className}>
        {children}
      </div>
    </TabsContext.Provider>
  )
}

function TabsList({ children, className = '' }) {
  return (
    <div className={`tabs ${className}`}>
      {children}
    </div>
  )
}

function Tab({ children, value, className = '' }) {
  const context = useContext(TabsContext)
  if (!context) {
    throw new Error('Tab must be used within Tabs')
  }

  const isActive = context.value === value

  return (
    <button
      type="button"
      className={`tab ${isActive ? 'active' : ''} ${className}`}
      onClick={() => context.onChange(value)}
    >
      {children}
    </button>
  )
}

function TabsContent({ children, value, className = '' }) {
  const context = useContext(TabsContext)
  if (!context) {
    throw new Error('TabsContent must be used within Tabs')
  }

  if (context.value !== value) {
    return null
  }

  return <div className={className}>{children}</div>
}

Tabs.List = TabsList
Tabs.Tab = Tab
Tabs.Content = TabsContent

export default Tabs
